import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the UK production region (`enterprise.uk.wisesystems.io`)
 */
export const ukServerConfig: ServerBaseUrl = {
    apiServer: 'https://api.uk.wisesys.info',
    auroraApiServer: 'https://aurora-v2.wisesys.info',
    socketServer: 'wss://uk.socket.wisesys.info',
    auroraServer: '',
    environment: ServerEnvironment.UK,
    CIEnv: ServerCIEnvironment.PRODUCTION,
    vehicleProfile:
        'https://lk8db1jmye.execute-api.eu-west-2.amazonaws.com/London',
    routePathGeometryServer:
        'https://axcf5rwtva.execute-api.eu-west-2.amazonaws.com/production',
    configurableWorkflowServer:
        'https://zcqwzh2eue.execute-api.us-east-1.amazonaws.com/Prod',
    // TODO(CD-112): regional prod — Cognito differs from dcs-prod; needs own regional dcs stack
    driverCostServer: ''
};
